import {getOrders, itemQuantSet, removeItem, setSelected} from '../../api/orders';
import { toast } from '../../../components/utils/globals';
import { stringsMatch } from '../../../components/utils/coercion';

// initial state
const state = {
    "pending": [],
    "selected": "",
    "loading": true,
    "guest": true,
};

// getters
const getters = {
    ORDERS_PENDING: state => state.pending,
    ORDERS_SELECTED_ID: state => state.selected,
    ORDERS_LOADING: state => state.loading,
    ORDERS_GUEST: state => state.guest,
};

// actions
const actions = {
    ORDERS_LOAD({ commit, dispatch }) {
        const   Id = localStorage.getItem('order_selected'),
                ordersTemp = localStorage.getItem('orders_pending');
        if(ordersTemp){
            let orders = JSON.parse(ordersTemp);
            commit('ORDERS_SET', orders);
            dispatch('ORDERS_SET_SELECTED', {Id: Id || orders[0].Id});
            commit('ORDERS_LOADING', false);
        } 
        else {
            commit('ORDERS_LOADING', true);
        }
        getOrders({type:'pending'})
            .then(({orders, selected}) => {
                commit('ORDERS_SET', orders);
                dispatch('ORDERS_SET_SELECTED', {Id: Id || selected || orders[0].Id});
                localStorage.setItem('orders_pending',JSON.stringify(orders));
            })
            .catch(()=>{
                toast({message:'Error Loading Orders. Please refresh in a few minutes.',theme:'error'})
            })
            .finally(()=>commit('ORDERS_LOADING', false));
    },
    ORDERS_APPEND({ commit }, order) {
        commit('ORDERS_APPEND', order);
    },
    ORDERS_SET_SELECTED({ commit }, {Id}) {
        let previousId = state.selected,
            NewId = state.pending.find(order => stringsMatch(Id, order.Id)) ? Id : (state.pending[0] || {Id:''}).Id;
        if(!previousId || !stringsMatch(previousId, NewId)){
            commit('ORDERS_SET_SELECTED', NewId);
            return setSelected({Id:NewId})
                .then(()=>localStorage.setItem('order_selected',Id))
                .catch(()=>{
                    commit('ORDERS_SET_SELECTED', previousId || NewId);
                });    
        }
    },
    ORDERS_ITEM_QUANT_SET({ commit }, {Part, Price, Condition, WarehouseId, Quantity, Searched, change, add}) {
        let Order = state.selected,
            promise = itemQuantSet({Order, Part, Price, Condition, WarehouseId, Quantity, Searched, add });
        promise.then( () => {
            commit('ORDER_INC', parseInt(change || Quantity));
        });
        return promise;
    },
    ORDERS_ITEM_REMOVE({ commit }, {Part, Price, Condition, WarehouseId, Quantity}) {
        let Order = state.selected,
            promise = removeItem({Order, Part, Price, Condition, WarehouseId });
        promise.then( () => {
            commit('ORDER_INC', parseInt(-Quantity));
        });
        return promise;
    },
    ORDER_SET_NAME({ commit }, {Name}) {
        commit('ORDER_SET_NAME', Name);
    },
};

// mutations
const mutations = {
    ORDERS_LOADING(state, loading){
        state.guest = false;
        state.loading = loading;
    },
    ORDERS_SET(state, orders) {
        state.pending = orders;
    },
    ORDERS_APPEND(state, order) {
        state.pending.unshift(order);
        localStorage.setItem('orders_pending',JSON.stringify(state.pending));
    },
    ORDERS_SET_SELECTED(state, orderId) {
        state.selected = orderId.toString();
    },
    ORDER_INC(state,qty){
        state.pending.find(({Id}) => stringsMatch(state.selected, Id)).Quantity += qty;
        localStorage.setItem('orders_pending',JSON.stringify(state.pending));
    },
    ORDER_SET_NAME(state,name){
        state.pending.find(({Id}) => stringsMatch(state.selected, Id)).Name = name;
        localStorage.setItem('orders_pending',JSON.stringify(state.pending));
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};